import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";
import { useDispatch, useSelector } from "react-redux";
import biddingGeneratorService from "../../components/Services/biddingGenerator.service";
import biddingConsumerService from "../../components/Services/biddingConsumer.service";
import { CircularProgress } from "@mui/material";
import { ChildCapacity } from "./childCapacity";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomConfirmBox from "./customConfirmBox";
import CapacityEditHistory from "./capacityEditHistory/capacityEditHistory";
import axios from "axios";
import { useSpring, animated } from "react-spring";
import { disableButton, enableButton } from "../../store/ButtonFlag/actions";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";

const AddBidsModal = ({
  isOpen,
  closeAddsBidsModal,
  handlePlaceBidText,
  getMatchingProfiles,
  getMatchingProfilesCon,
  bidItem,
  selectedCardData,
  bitType,
}) => {
  console.debug("bitType", bitType);
  const dispatch = useDispatch();
  const role = useSelector((state) => state?.sessionState?.role);
  const configKey = useSelector((state) => state?.sessionState?.connectionName);
  const isButtonEnabled = useSelector(
    (state) => state?.buttonReducer?.isButtonEnabled
  );

  const [isLoading, setIsLoading] = useState(false);
  const [bidsListing, setBidsListing] = useState(null);
  const [isChild, setIsChild] = useState(false);
  const [withdrawOpen, setWithdrawOpen] = useState(false);
  const [capHistory, setCapHistory] = useState(false);

  const getBidsListing = (id) => {
    setIsLoading(true);
    if (role === "GENERATOR") {
      biddingGeneratorService
        .getBidsListByConCapacityId(selectedCardData?.id, id)
        .then((response) => {
          if (response?.data?.code === 200) {
            setBidsListing(response?.data?.data);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.error("Api call error:", error);
        });
    } else if (role === "CONSUMER") {
      biddingConsumerService
        .getBidsListByGenCapacityId(id, selectedCardData?.id)
        .then((response) => {
          if (response?.data?.code === 200) {
            setBidsListing(response?.data?.data);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.error("Api call error:", error);
        });
    }
  };
  useEffect(() => {
    if (isOpen === true) {
      getBidsListing(bidItem?.id);
    }
  }, [isOpen]);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          "https://4ltgnhi4rg.execute-api.us-west-2.amazonaws.com/gnaenergy"
        );
        setData(response?.data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchData();
  }, []);
  const initialValues = {
    amount: bidItem?.isEditable
      ? bidsListing?.ownBid?.amount || ""
      : (role === "CONSUMER"
        ? selectedCardData?.landingCost
        : selectedCardData?.sellingCost) || "",
    CalLandedCost: bidItem?.isEditable
      ? role === "CONSUMER"
        ? bidsListing?.ownBid?.calculatedGeneratorCost?.toFixed(2)
        : bidsListing?.ownBid?.calculatedLandedCost?.toFixed(2) || ""
      : (role === "CONSUMER"
        ? bidItem?.consumerLandedCost?.toFixed(2)
        : bidItem?.generatorPerUnitCost?.toFixed(2)) || "",

    energy: bidItem?.isEditable
      ? bidsListing?.ownBid?.quantity || ""
      : (role === "CONSUMER"
        ? selectedCardData?.purchaseEnergy
        : selectedCardData?.sellEnergy) || "",
  };
  const closeChildCapacityModal = () => {
    setIsChild(false);
  };
  const openChildCapacityModal = () => {
    setIsChild(true);
  };
  const openCapacityHistoryModal = () => {
    setCapHistory(true);
  };
  const closeCapacityEditHistoryModal = () => {
    setCapHistory(false);
  };
  const handleConnectionRequest = () => {
    disableButton()(dispatch);
    const requestBody = {
      id: bidItem?.isEditable === true ? bidsListing?.childCapacity?.id : null,
      name: bidsListing?.childCapacity?.name,
      quantity:
        role === "CONSUMER"
          ? bidsListing?.childCapacity?.purchaseEnergy
          : bidsListing?.childCapacity?.sellEnergy,
      amount:
        role === "CONSUMER"
          ? bidsListing?.childCapacity?.landingCost
          : bidsListing?.childCapacity?.sellingCost,
      generatorStatus: role === "GENERATOR" ? "PLACED" : "RECEIVED",
      consumerStatus: role === "CONSUMER" ? "PLACED" : "RECEIVED",
      [role === "GENERATOR" ? "capacityConsumerId" : "capacityGeneratorId"]:
        bidItem?.id,
      [role === "GENERATOR" ? "capacityGeneratorId" : "capacityConsumerId"]:
        selectedCardData?.id,
      dateStartAt: bidsListing?.childCapacity?.dateStartAt,
      dateEndAt: bidsListing?.childCapacity?.dateEndAt,
      slotStartAt: bidsListing?.childCapacity?.slotStartAt,
      slotEndAt: bidsListing?.childCapacity?.slotEndAt,
      tcRequest: bitType === "TRADECONNECT",
      otcRequest: bitType === "OTC",
    };
    role === "GENERATOR"
      ? biddingGeneratorService
        .placeBidGenerator(requestBody)
        .then((response) => {
          if (response?.data?.code === 200) {
            toast.success(`${response?.data?.message}`, toastProperties);
            getMatchingProfiles(selectedCardData?.id);
            closeChildCapacityModal();
            closeAddsBidsModal();
            handlePlaceBidText(bidItem?.id);
            enableButton()(dispatch);
          } else if (response?.data?.code !== 200) {
            enableButton()(dispatch);
          }
        })
        .catch((error) => {
          console.error("API call error", error);
          enableButton()(dispatch);
        })
      : biddingConsumerService
        .placeBidConsumer(requestBody)
        .then((response) => {
          if (response?.data?.code === 200) {
            enableButton()(dispatch);
            toast.success(`${response?.data?.message}`, toastProperties);
            getMatchingProfilesCon(selectedCardData?.id);
            closeChildCapacityModal();
            closeAddsBidsModal();
            handlePlaceBidText(bidItem?.id);
          } else if (response?.data?.code !== 200) {
            enableButton()(dispatch);
          }
        })
        .catch((error) => {
          console.error("API call error", error);
          enableButton()(dispatch);
        });
  };

  const handleWithdraw = () => {
    setWithdrawOpen(true);
  };

  const handleWithdrawClose = () => {
    disableButton()(dispatch);
    const data = {
      id: bidsListing?.childCapacity?.id,
      status: "WITHDRAWN",
      isPlaced: true,
    };
    if (role === "GENERATOR") {
      biddingGeneratorService
        .updateConnectionStatus(data)
        .then((response) => {
          if (response?.data?.code === 200) {
            setWithdrawOpen(false);
            enableButton()(dispatch);
            getMatchingProfiles(selectedCardData?.id);
            closeChildCapacityModal();
            closeAddsBidsModal();
            toast.success("Status updated successfully", toastProperties);
          } else if (response?.data?.code !== 200) {
            enableButton()(dispatch);
          }
        })
        .catch((error) => {
          console.error("Api call Error :", error);
          enableButton()(dispatch);
        });
    } else if (role === "CONSUMER") {
      biddingConsumerService
        .updateConnectionStatus(data)
        .then((response) => {
          if (response?.data?.code === 200) {
            setWithdrawOpen(false);
            getMatchingProfilesCon(selectedCardData?.id);
            closeChildCapacityModal();
            closeAddsBidsModal();
            toast.success("Status updated successfully", toastProperties);
          } else if (response?.data?.code !== 200) {
            enableButton()(dispatch);
          }
        })
        .catch((error) => {
          console.error("Api call Error :", error);
          enableButton()(dispatch);
        });
    }
  };
  const handleWithdrawCloseNo = () => {
    setWithdrawOpen(false);
  };

  const styles = useSpring({
    from: { transform: "translateX(100%)" },
    to: { transform: "translateX(-70%)" },
    config: { duration: "15000" },
    loop: true,
  });
  const handlePushToTradeConnectPlatform = () => {
    disableButton()(dispatch);
    const reqBoby = {
      childCapacityId: bidsListing?.childCapacity?.id,
      type: "PLACED",
    };
    if (role === "CONSUMER") {
      biddingConsumerService
        .pushToTradeConnectFromConRole(reqBoby)
        .then((response) => {
          if (response?.data?.code === 200) {
            closeAddsBidsModal();
            getMatchingProfilesCon(selectedCardData?.id);
            toast.success(response?.data?.message, toastProperties);
            enableButton()(dispatch);
          } else {
            enableButton()(dispatch);
          }
        })
        .catch((err) => console.log("Api Call Err:", err));
    } else if (role === "GENERATOR") {
      biddingGeneratorService
        .pushToTradeConnectFromGenRole(reqBoby)
        .then((response) => {
          if (response?.data?.code === 200) {
            closeAddsBidsModal();
            getMatchingProfiles(selectedCardData?.id);
            toast.success(response?.data?.message, toastProperties);
            enableButton()(dispatch);
          } else {
            enableButton()(dispatch);
          }
        })
        .catch((err) => console.log("Api Call Err:", err));
    }
  };
  return (
    <>
      {capHistory && (
        <Modal
          className="modal"
          show={capHistory}
          size="xl"
          onHide={closeCapacityEditHistoryModal}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Listing History</Modal.Title>
          </Modal.Header>
          <Modal.Body className="table-scrollY">
            <CapacityEditHistory
              setIsLoading={setIsLoading}
              bidItem={bidItem}
              show={capHistory}
              closeCapacityEditHistoryModal={closeCapacityEditHistoryModal}
            />
          </Modal.Body>
        </Modal>
      )}
      {isChild && !capHistory ? (
        <Modal
          className="modal"
          show={isChild}
          size="xl"
          onHide={closeChildCapacityModal}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <span style={{ textTransform: "capitalize" }}>
                Send your {configKey} Request
              </span>
            </Modal.Title>
          </Modal.Header>
          {isLoading ? (
            <div className="text-center" style={{ maxHeight: "500px" }}>
              <CircularProgress />
            </div>
          ) : (
            <Modal.Body className="table-scrollY">
              <ChildCapacity
                bidsListing={bidsListing}
                selectedCardData={selectedCardData}
                bidItem={bidItem}
                closeChildCapacityModal={closeChildCapacityModal}
                closeAddsBidsModal={closeAddsBidsModal}
                handlePlaceBidText={handlePlaceBidText}
                getMatchingProfiles={getMatchingProfiles}
                getMatchingProfilesCon={getMatchingProfilesCon}
                bitType={bitType}
              />
            </Modal.Body>
          )}
        </Modal>
      ) : (
        <Modal
          show={isOpen}
          className="modal"
          size="xl"
          onHide={closeAddsBidsModal}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <span style={{ textTransform: "capitalize" }}>
                {configKey} Request
              </span>
            </Modal.Title>
          </Modal.Header>
          {isLoading ? (
            <div className="text-center" style={{ maxHeight: "500px" }}>
              <CircularProgress />
            </div>
          ) : (
            <Modal.Body className="modal-scrollY ">
              {data && (
                <div>
                  <animated.div style={styles}>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "15px",
                        fontFamily: "sans-serif",
                      }}
                    >
                      <div>
                        DAM Price (₹/KWh) <span className="fw-bold">:</span>
                      </div>
                      <div>
                        Current Day :-{" "}
                        <span className="fw-bold">{data?.cur_day}</span>
                      </div>
                      <div>
                        Previous Day :-{" "}
                        <span className="fw-bold">{data?.prev_day}</span>
                      </div>
                      <div>
                        Previous Year :-{" "}
                        <span className="fw-bold">{data?.prev_year}</span>
                      </div>
                      <div>
                        Average (TTM) :-{" "}
                        <span className="fw-bold">{data?.ttm}</span>
                      </div>
                    </div>
                  </animated.div>
                </div>
              )}
              <div className=" container my-2">
                <Formik
                  initialValues={initialValues}
                  onSubmit={(values) => { }}
                // validationSchema={validationSchema}
                >
                  {({ values, setFieldValue, setFieldTouched, setValues }) => {
                    return (
                      <Form>
                        <div className="capacity-slots-col mb-4">
                          {selectedCardData && (
                            <div
                              className="capacity-slots-col-card mx-auto"
                              key={selectedCardData?.id}
                            >
                              <div className=" pull-right clearfix">
                                {/* <i className='fa fa-pencil c-icons'></i> */}
                              </div>
                              <h6 className=" text-center">My Listing</h6>
                              <h6 className=" text-center">
                                {bidsListing?.childCapacity?.name}
                              </h6>
                              <div className="dashboard-slot dashboard-slot-date-time my-3 justify-content-center">
                                <div>
                                  <div>
                                    {bidsListing?.childCapacity?.dateStartAt}
                                  </div>
                                </div>
                                <div>-</div>
                                <div>
                                  <div>
                                    {bidsListing?.childCapacity?.dateEndAt}
                                  </div>
                                </div>
                              </div>
                              <div className="dashboard-slot dashboard-slot-date-time my-3 justify-content-center">
                                <div>
                                  <div>
                                    {bidsListing?.childCapacity?.slotStartAt}
                                  </div>
                                </div>
                                <div>-</div>
                                <div>
                                  <div>
                                    {bidsListing?.childCapacity?.slotEndAt &&
                                      (bidsListing?.childCapacity?.slotEndAt ===
                                        "23:59"
                                        ? "24:00"
                                        : bidsListing?.childCapacity
                                          ?.slotEndAt)}
                                  </div>
                                </div>
                              </div>
                              <div className="testfortest">
                                <div className="energy-cost-unit-box w-100">
                                  <div
                                    className="energy-cost-unit-box-content"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    Quantity (MW) :
                                    <Field
                                      type="text"
                                      name="sellEnergy"
                                      className="energy-cost-unit-field-content"
                                      readOnly
                                      placeholder={`${(role === "CONSUMER"
                                        ? bidsListing?.childCapacity
                                          ?.purchaseEnergy
                                        : bidsListing?.childCapacity
                                          ?.sellEnergy) || 0
                                        }`}
                                    />
                                  </div>
                                  <div
                                    className="energy-cost-unit-box-content"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    Energy Rate (₹ per unit) :
                                    <Field
                                      type="text"
                                      name="sellAmount"
                                      className="energy-cost-unit-field-content"
                                      readOnly
                                      placeholder={`${(role === "CONSUMER"
                                        ? bidsListing?.childCapacity
                                          ?.landingCost
                                        : bidsListing?.childCapacity
                                          ?.sellingCost) ||
                                        bidsListing?.childCapacity
                                          ?.energyRateStr ||
                                        0
                                        }`}
                                    />
                                  </div>
                                </div>
                                <div className="c-icons-group-child-cap">
                                  {bitType !== "TRADECONNECT" && (
                                    <div
                                      onClick={(e) => {
                                        openChildCapacityModal();
                                      }}
                                    >
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>Edit Capacity</Tooltip>
                                        }
                                      >
                                        <div>
                                          <i className="fa fa-pencil c-icons"></i>
                                        </div>
                                      </OverlayTrigger>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="small mt-3 text-center">
                                Expiry on {selectedCardData?.bidEndAt}
                              </div>
                            </div>
                          )}
                          {bidItem && (
                            <div
                              className="capacity-slots-col-card mx-auto"
                              key={bidItem?.id}
                            >
                              <h6 className=" text-center">
                                {role === "CONSUMER" ? "Generator" : "Consumer"}{" "}
                                Listing
                              </h6>
                              <h6 className=" text-center">
                                {bidItem?.capacityName}
                              </h6>
                              <div className="dashboard-slot dashboard-slot-date-time my-3 justify-content-center">
                                <div>
                                  <div>{bidItem?.dateStartAt}</div>
                                </div>
                                <div>-</div>
                                <div>
                                  <div>{bidItem?.dateEndAt}</div>
                                </div>
                              </div>
                              <div className="dashboard-slot dashboard-slot-date-time my-3 justify-content-center">
                                <div>
                                  <div>{bidItem?.slotStartAt}</div>
                                </div>
                                <div>-</div>
                                <div>
                                  <div>
                                    {bidItem?.slotEndAt &&
                                      (bidItem?.slotEndAt === "23:59"
                                        ? "24:00"
                                        : bidItem?.slotEndAt)}
                                  </div>
                                </div>
                              </div>
                              <div className="testfortest">
                                <div className="energy-cost-unit-box w-100">
                                  <div
                                    className="energy-cost-unit-box-content"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    Quantity (MW) :
                                    <Field
                                      type="text"
                                      name="itemEnergy"
                                      className="energy-cost-unit-field-content"
                                      readOnly
                                      placeholder={`${(role === "CONSUMER"
                                        ? bidItem?.energyInMW
                                        : bidItem?.energyInMW) || 0
                                        } `}
                                    />
                                  </div>
                                  <div
                                    className="energy-cost-unit-box-content"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    Energy Rate (₹ per unit) :
                                    <Field
                                      type="text"
                                      name="itemAmount"
                                      className="energy-cost-unit-field-content"
                                      readOnly
                                      placeholder={` ${(role === "CONSUMER"
                                        ? bidItem?.generatorPerUnitCost
                                        : bidItem?.consumerLandedCost) ||
                                        bidsListing?.childCapacity
                                          ?.energyRateStr ||
                                        0
                                        }`}
                                    />
                                  </div>
                                </div>
                                <div className="c-icons-group-child-cap">
                                  <div
                                    onClick={(e) => {
                                      openCapacityHistoryModal();
                                    }}
                                  >
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>View History</Tooltip>}
                                    >
                                      <div className="c-icons">
                                        <HistoryToggleOffIcon />
                                      </div>
                                    </OverlayTrigger>
                                  </div>
                                </div>
                              </div>
                              <div className="small mt-3 text-center">
                                Expiry on {bidItem?.expiryAt}
                              </div>
                            </div>
                          )}
                        </div>
                        {/* <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', fontFamily: 'sans-serif' }}>
                      <div>{role === 'CONSUMER' ? "Calculated Landed Cost" : "Calculated Generator Cost Ex-bus"}
                        <span className='fw-bold'>:&nbsp;
                          {(role === 'CONSUMER' ? bidItem?.consumerLandedCost?.toFixed(2) || "NA" : bidItem?.generatorPerUnitCost?.toFixed(2)) || 'NA'}
                        </span>
                      </div>
                    </div> */}
                        <div className="table-responsive doc-cus-table my-4">
                          {bidsListing?.otherBids?.length > 0 ? (
                            <>
                              <div style={{ fontFamily: "sans-serif" }}>
                                Other{" "}
                                {role === "CONSUMER"
                                  ? "Consumers"
                                  : "Generators"}{" "}
                                Interested in this Listing:
                              </div>
                              <table className="cus-table table-bordered my-documents-table">
                                <thead className="table-header">
                                  <tr>
                                    <th>S.no</th>
                                    <th>
                                      Energy Rate (₹ per Unit)
                                      {/* <br /><small style={{ fontSize: '12px' }}>{role === 'CONSUMER' ? '(Consumer Landed Cost)' : '(Generator Cost Ex-bus)'}</small> */}
                                    </th>
                                    {/* <th>{role === 'CONSUMER' ? 'Generator Cost Ex-bus (₹ per Unit)' : 'Consumer Landed Cost (₹ per Unit)'}<br /><small style={{ fontSize: '12px' }}>(Calculated)</small></th> */}
                                    <th> Quantity (MW)</th>
                                  </tr>
                                </thead>
                                {role === "CONSUMER" ? (
                                  <tbody>
                                    {bidsListing?.otherBids?.map((item, i) => (
                                      <tr key={item?.id}>
                                        <td>{i + 1}</td>
                                        <td>{item?.energyRateStr ? item?.energyRateStr : item?.amount?.toFixed(2)}</td>
                                        {/* <td>{item?.calculatedGeneratorCost?.toFixed(2)}</td> */}
                                        <td>{item?.quantity}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                ) : (
                                  <tbody>
                                    {bidsListing?.otherBids?.map((item, i) => (
                                      <tr key={item?.id}>
                                        <td>{i + 1}</td>
                                        <td>{item?.energyRateStr ? item?.energyRateStr : item?.amount?.toFixed(2)}</td>
                                        {/* <td>{item?.calculatedLandedCost?.toFixed(2)}</td> */}
                                        <td>{item?.quantity}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                )}
                              </table>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        {bitType === "TRADECONNECT" ? (
                          <div className="company-profile-btn-group mt-4 justify-content-center">
                            <button
                              type="button"
                              className="btn btn-login"
                              disabled={isButtonEnabled}
                              onClick={handleConnectionRequest}
                            >
                              Connect
                            </button>
                            {bidsListing?.childCapacity?.id &&
                              bidItem?.isEditable && (
                                <button
                                  className="btn btn-withdrawal"
                                  type="button"
                                  onClick={handleWithdraw}
                                >
                                  {" "}
                                  Withdraw{" "}
                                </button>
                              )}
                          </div>
                        ) : (
                          <div className="company-profile-btn-group mt-4 justify-content-center">
                            <button
                              type="button"
                              className="btn btn-login"
                              disabled={isButtonEnabled}
                              onClick={handleConnectionRequest}
                            >
                              Connect
                            </button>
                            {bidsListing?.childCapacity?.id &&
                              bidItem?.isEditable && (
                                <button
                                  className="btn btn-withdrawal"
                                  type="button"
                                  onClick={handleWithdraw}
                                >
                                  {" "}
                                  Withdraw{" "}
                                </button>
                              )}
                          </div>
                        )}
                        {withdrawOpen && (
                          <CustomConfirmBox
                            title="Withdraw"
                            message={`Do you want to withdraw this ${configKey}?`}
                            open={withdrawOpen}
                            handleClose={handleWithdrawClose}
                            handleCloseNo={handleWithdrawCloseNo}
                          />
                        )}
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </Modal.Body>
          )}
        </Modal>
      )}
    </>
  );
};

export default AddBidsModal;
